import * as React from 'react';
export const cloudSvg = React.forwardRef(function cloudSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6.63 3a3.25 3.25 0 0 0-3.25 3.25c0 .263.033.525.055.787C2.335 7.5 1.5 8.42 1.5 9.75c0 1.55 1.194 2.75 2.596 2.75h7.808c1.402 0 2.596-1.2 2.596-2.75S13.306 7 11.904 7H9.88v-.75A3.25 3.25 0 0 0 6.63 3ZM1.88 6.175a4.75 4.75 0 0 1 9.44-.675h.584C14.197 5.5 16 7.435 16 9.75S14.197 14 11.904 14H4.096C1.803 14 0 12.065 0 9.75a4.29 4.29 0 0 1 1.88-3.575Z',
    }),
  );
});
cloudSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cloud = {
  category: 'icon',
  colorable: true,
  name: 'cloud',
  svg: cloudSvg,
};
